import React, { useRef } from 'react'
import { MessageSwitchProps } from '../MessageSwitch'
import { MessageWrapper } from './MessageWrapper'
import classNames from 'classnames'
import { MessageInfo } from '~/service/chatConn/types'

export type TextAnswerProps = MessageSwitchProps<MessageInfo>

const Info: React.FC<TextAnswerProps> = ({ ...props }) => {
  const { message } = props

  const ref = useRef<HTMLDivElement>(null)

  return (
    <>
      <MessageWrapper {...props} className={classNames('is-info')} _ref={ref}>
        <span
          dangerouslySetInnerHTML={{
            __html: message.content,
          }}
        />
      </MessageWrapper>
    </>
  )
}

export default Info
